import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
function AboutThree() {

    const location = useLocation();
    const [isVideoOpen, setIsVideoOpen] = useState(false);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            const headerHeight = 100;
            const elementPosition = element.offsetTop - headerHeight;
            
            window.scrollTo({
                top: elementPosition,
                behavior: 'smooth'
            });
            window.history.pushState(null, null, `#${sectionId}`);
        }
    };

    const handleAboutClick = (e, sectionId, path) => {
        if (location.pathname === '/') {
            e.preventDefault();
            scrollToSection(sectionId);
        }
    };

    // Function to open the video overlay
    const openVideo = (e) => {
        e.preventDefault();
        setIsVideoOpen(true);
    };

    // Function to close the video overlay
    const closeVideo = (e) => {
        e.preventDefault();
        setIsVideoOpen(false);
    };

    // Effect to handle the escape key for closing the video overlay
    useEffect(() => {
        const handleKeyUp = (e) => {
            if (e.keyCode === 27) {
                setIsVideoOpen(false);
            }
        };

        // Add event listener for keyup
        document.addEventListener('keyup', handleKeyUp);

        // Cleanup function to remove event listener on component unmount
        return () => {
            document.removeEventListener('keyup', handleKeyUp);
        };
    }, []);
    return (
        <div>
            {/* start about area two */}
            <div className="rts-about-area-two rts-section-gap about-two-bg">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-5">
                            <div className="about-three-thumbnail-left">
                                <img src={`${process.env.PUBLIC_URL}/assets/images_new/about_05.jpg`} alt="Izodrom-Grup-constructions" />
                                <div className="about-sm-thumb">
                                    <img
                                        src={`${process.env.PUBLIC_URL}/assets/images_new/about-01-sm.jpg`}
                                        alt="izodrom-infrastructure"
                                    />
                                </div>
                               
                            </div>
                        </div>
                        <div className="col-lg-7 pl--50 pl_md--15 pl_sm--15">
                            <div className="about-right-three">
                                <div className="title-area-about-three">
                                    <span className="sub">Fondată în 2001</span>
                                    <h2 className="title">
                                        Lider în Infrastructură <br />
                                        <span>
                                            Inginerească <span>din Moldova</span>
                                        </span>
                                    </h2>
                                </div>
                                <div className="inner-about-three">
                                    <p className="disc">
                                    Izodrom Grup, cu sediul în Ialoveni, este o companie specializată în construția obiectelor inginerești, dedicată în principal proiectelor industriale de mediu și utilități. Ne concentrăm pe proiectarea și execuția completă a stațiilor de epurare a apelor uzate, rețelelor de alimentare cu apă și canalizare, lucrărilor de terasamente, precum și pe montajul echipamentelor tehnologice, inclusiv cazangerii. Cu experiență în reconstrucția și modernizarea stațiilor din localități precum Căușeni și Florești, Cricova susținem comunitățile prin infrastructură durabilă și soluții eficiente, oferite „la cheie” prin colaborări solide și execuție atentă.
                                    </p>
                                    {/* start */}
                                    <div className="row">
                                        {/* start */}
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                                            <div className="solution-wrapper">
                                                {/* single business solution */}
                                                <div className="single-business-solution">
                                                    <i className="far fa-check" />
                                                    <p>Construcții Civile & Industriale</p>
                                                </div>
                                                {/* single business solution */}
                                                {/* single business solution */}
                                                <div className="single-business-solution">
                                                    <i className="far fa-check" />
                                                    <p>Stații de Epurare Moderne</p>
                                                </div>
                                                {/* single business solution */}
                                                {/* single business solution */}
                                                <div className="single-business-solution">
                                                    <i className="far fa-check" />
                                                    <p>Sisteme Apă & Canalizare</p>
                                                </div>
                                                {/* single business solution */}
                                                {/* single business solution */}
                                                <div className="single-business-solution">
                                                    <i className="far fa-check" />
                                                    <p>Lucrări de Terasamente</p>
                                                </div>
                                                {/* single business solution */}
                                            </div>
                                        </div>
                                        {/* end */}
                                        {/* start */}
                                        <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                                            <div className="solution-wrapper-right">
                                                {/* single business solution */}
                                                <div className="single-business-solution">
                                                    <i className="far fa-check" />
                                                    <p>Tehnologii MBBR Avansate</p>
                                                </div>
                                                {/* single business solution */}
                                                {/* single business solution */}
                                                <div className="single-business-solution">
                                                    <i className="far fa-check" />
                                                    <p>Instalații & Montaj Protecție</p>
                                                </div>
                                                {/* single business solution */}
                                                {/* single business solution */}
                                                <div className="single-business-solution">
                                                    <i className="far fa-check" />
                                                    <p>Finisaje & Lucrări Specializate</p>
                                                </div>
                                                {/* single business solution */}
                                                {/* single business solution */}
                                                <div className="single-business-solution">
                                                    <i className="far fa-check" />
                                                    <p>Suport Tehnic Complet</p>
                                                </div>
                                                {/* single business solution */}
                                            </div>
                                        </div>
                                        {/* end */}
                                    </div>
                                </div>
                                {/*usrer aresa start */}
                                <div className="row">
                                    <div className="col-l2">
                                        <div className="rts-user-three-wrapper">
 
                                            <div className="reviews">
                                                <h5 className="title">20+</h5>
                                                <h6>Ani de Experiență</h6>
                                            </div>
                                            <Link
                                                to="/project"
                                                className="rts-btn btn-primary-3 color-h-black ml--35"
                                                onClick={(e) => handleAboutClick(e, 'projects', '/project')}
                                            >
                                                Vezi Proiectele
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                {/*usrer aresa end */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* end about area two */}
        </div>
    )
}

export default AboutThree